module.exports = __webpack_public_path__ + "static/media/Cat_Treat.e3f86d32.jpg";